export default {
  path: 'https://arco.design/vue/docs/pro/faq',
  name: 'faq',
  meta: {
    locale: 'menu.faq',
    icon: 'icon-question-circle',
    requiresAuth: true,
    order: 9,
  },
};
